<template>
    <div class="list-container">
        <div :class="{ responses: responses }">
            <p class="list-title">{{ title }}</p>
            <p class="list-count">Count : {{ count }}</p>
            <p class="clear-filter" v-if="title == 'Members'"><span>Show All</span><input type="checkbox" @click="clearFilter($event)"/></p>
            <div class="x" @click="$emit('emit',{ action: 'exit' })"></div>
            <p class="btn sm" v-if="['responses-list'].indexOf(t) > -1" style="position: absolute;right:200px;top: -2px" @click="download">download</p>
        </div>
        <div class="list-search" :style="{ 'grid-template-columns': grid }">
            <div class="item-search" v-for="(field,i) in fields" :key="i" @keyup="search" @change="search">
                <p :class="['order',field.order || '']" @click="order(field)"></p><p>{{ field.title }}</p>
                <input v-model="field.value" />
            </div>
        </div>
        <div class="list-items">
            <div v-for="(item,k) in items.concat(LocalItems)" :key="k" class="list-item-container" >
                <div class="list-item" :style="{ 'grid-template-columns': grid }" :id="item._id" :key="item._id">
                    <div v-for="(field,i) in fields" :key="i">
                        <p 
                            :class="(field.class || '')+' ellip'" 
                            @click="$emit('emit',{ t: t, field: field, item: item, value: item[field.field], e: $event })" 
                            v-html="( i == 0 && Array.isArray(item.components) && `<span class='order l-${item.components.length}'></span>` || '' ) +( typeof field.map == 'function' ? field.map(item) : ( item[field.field] || '' ) )"
                            ></p>
                    </div>
                </div>
                <component v-for="(component,i) in item.components" :key="i" :is="component" :item="item" @exit="$emit('emit',{ t: 'component', action: 'exit', item: item })"></component>
            </div>
        </div>
        <div class="btns">
            <p class="btn" v-if="t == 'survey-list'" @click="$emit('emit',{ t: t, action: 'send' })" style="width: 200px;">send ( no campaign )</p>
            <p class="btn" v-if="['refer-list','ad-list','customer-list','messages-list','responses-list','wallet-list'].indexOf(t) == -1" @click="$emit('emit',{ t: t, action: 'new' })">new</p>
            
        </div>
        <div v-if="downloading" class="fixed-scroller downloading" @click="downloading = false">
            <div class="bar">
                <div class="progress" :style="{ width: 'calc('+((downloading.progress / downloading.count) * 100 )+'% - 10px)' }"></div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapMutations, mapActions } from 'vuex'
import WebSoc from '@/utils/WebSoc.js'
import { distanceInWordsStrict, format, isToday } from 'date-fns'
import distanceDate from '@/utils/distanceDate.js'
import Alert from '@/utils/Alert.js'
import watchDB from '../utils/watchDB.js'
import memberDetail from '../components/memberDetail';
import WalletList from '../components/WalletList.vue'
export default {
    props: ['DB'],
    components: {
        memberDetail,
        WalletList
    },
    computed: {
        items () {
            if ( this.DB.storeDB ) {
                var db = this.DB.DB;
                if ( db == 'jb-ads' ) db = 'ads';
                if ( db == 'surveys' ) db = 'campaigns';
                if ( db == 'refer-links' ) db = 'referrals'
                return this.$store.state.DB[db];
            } else {
                return []
            }
        }
    },
    data () {
        return {
            count: 0,
            t: 'project-list',
            mDB: '',
            title: '',
            grid: '',
            fields: [],
            LocalItems: [],
            project: {},
            dateFields: [],
            responses: false,
            Search: false,
            downloading: false,
            subComponent: ''
        }
    },
    created () {
        var DB = this.DB;
        Object.keys(DB).forEach(key => {
            switch ( key ) {
                case 'DB': return this.mDB = DB[key];
                case 'title': return this[key] = DB[key];
                case 'fields': return this[key] = DB.fields.map(f => { return ['title','field','class','type','width','map','order','date','format'].reduce((p,F) => { p[F] = f[F]; return p },{}) })
                case 't': return this[key] = DB[key];
                case 'project': return this[key] = JSON.parse(JSON.stringify(DB[key]));
                case 'subComponent': return this.subComponent = DB[key];
            }
        })
        this.grid = this.fields.map(f => {
            f.value = '';
            f.order = f.order || '';
            this.project[f.field] = 1;
            if ( typeof f.width == 'string' ) return f.width;
            if ( typeof f.width == 'number' ) return f.width + 'px';
            return '100px'
        }).join(' ');
        this.dateFields = this.fields.filter(f => { return f.type == 'date' && f.format });
        //console.log('dateFields',this.dateFields);
    },
    beforeDestroy () {
        this.DB.watch && this.stopWatch();
    },
    mounted () {
        if ( this.DB.DB.indexOf('-responses') > -1 ) {
            this.responses = true;
        }
        this.search();
        this.DB.watch && this.startWatch();
    },
    methods: {
        clearFilter ( e ) {
            console.log('before this.DB.filter',JSON.parse(JSON.stringify(this.DB.filter)));
            if ( e.target.checked ) {
                this._filter = JSON.stringify(this.DB.filter);
                var client_id = this.DB.filter.client_id;
                this.DB.filter = {};
                if ( client_id ) { this.DB.filter.client_id = client_id; }

            } else {
                this.DB.filter = JSON.parse(this._filter);
            }
            console.log('after this.DB.filter',JSON.parse(JSON.stringify(this.DB.filter)));
            this.search();
        },
        startWatch () {
            WebSoc.SEND('startWatch',{ DB: this.DB.DB, filter: this.DB.watch },update => {
                console.log('startWatch update',update);
                update.$watch && watchDB({ items: this.LocalItems, $watch: update.$watch })
                update.$watch && this.$forceUpdate();
            })
        },
        stopWatch () {
            WebSoc.SEND('stopWatch',{ DB: this.DB.DB, filter: this.DB.watch },resp => {
                console.log('resp',resp);
            })
        },
        download () {
            var filter = this.fields.filter(f => f.value);

            const completeDownload = csv => {
                if ( !this.downloading ) return;
                this.downloading = false;
                if ( this.DB.downloadTitle ) {
                    var fileName = this.DB.downloadTitle+' - '+format(Date.now(),'dd/MM/yy HH:mm')+'.csv'
                } else {
                    var fileName = 'Responses '+ format(Date.now(),'dd/MM/yy HH:mm')+'.csv'
                }
                this.downloadCSV({
                    fileName,
                    csv: csv.map(c => '"'+c.join('","')+'"').join('\n')
                })
            }

            const download = (all) => {
                var search = all ? this.DB.filter : this.Search;
                var orderby = this.Orderby;
                var fields = this.DB.fields;
                var project = this.project;
                this.downloading = true;
                var progress = 0;
                var csv = [ this.fields.map(f => f.title) ];
                WebSoc.SEND('search',{ DB: this.DB.DB, orderby, find: search, project, stream: true, count: true },item => {
                    !item._id && item.count && ( this.downloading = { count: item.count, progress: progress });
                    !item._id && item.complete && completeDownload(csv);
                    if ( !item._id ) return;

                    csv.push(this.fields.map(f => {
                        var field = f.field.split('.');
                        if ( typeof f.map == 'function' ) return f.map(item)
                        switch ( field.length ) {
                            case 1:
                                return item[field[0]];
                                break;
                            case 2: 
                                var value = item[field[0]];
                                    return value[field[1]];
                                break;    
                        }
                    }).map(f => typeof f == 'undefined' ? '' : f));

                    if ( this.downloading.count > 0 && ++this.downloading.progress >= this.downloading.count ) { completeDownload(csv); }
                });

            }

            if ( filter.length == 0 ) return download(true);

            Alert({
                header: 'Data Selection',
                message: 'The selection or all data',
                OK: 'all data',
                cancel: 'this selection'
            },yes => {
                if ( yes ) {
                    download(true)
                } else {
                    download(false);
                }
            });

        },
        order ( field ) {
            this.fields.forEach(Field => {
                if ( field != Field ) return Field.order = '';
                switch ( Field.order ) {
                    case 'asc': return Field.order = 'dec';
                    case 'dec': return Field.order = '';
                    case '': return Field.order = 'asc'
                }
                
            });
            this.$forceUpdate();
            this.search();
        },
        search ( e ) {

            var keyCode = e && e.keyCode;
            if ( [9,16,27,38,40].indexOf(keyCode) > -1 ) return;
            clearTimeout(this._search);
            this._search = setTimeout(() => {
                var DB = this.mDB;
                var orderby = {};
                var search = this.fields.reduce((p,field) => {
                    if ( field.order ) {
                        switch ( field.type ) {
                            case 'date':
                                orderby[field.field] = field.order == 'asc' ? -1 : 1;
                                break;
                            default: 
                            orderby[field.field] = field.order == 'asc' ? 1 : -1;
                        }
                        
                    }
                    if ( field.value.length == 0 ) { if ( typeof this.DB.filter[field.field] == 'undefined') delete p[field.field]; return p; };

                    if ( typeof field.onsearch == 'function' ) { 
                        p[field.field] = field.onsearch(field.value);
                    } else if ( field.type == 'num' ) {
                    var val = field.value;
                    var $lt = val.split('<')[1] && parseFloat(val.split('<')[1].split('>')[0]);
                    var $gt = val.split('>')[1] && parseFloat(val.split('>')[1].split('<')[0]);
                    if ( !isNaN($lt) ) { p[field.field] = { $lt: $lt } }
                    if ( !isNaN($gt) ) { p[field.field] = p[field.field] || {}; p[field.field].$gt = $gt; }
                    if ( !p[field.field]   ) { p[field.field] = { $eq: parseInt(val) } }
                    } else {
                        p[field.field] = { $regex: field.value, $options: 'i' }
                    }
                    return p;
                },JSON.parse(JSON.stringify(this.DB.filter || {})));

                if ( this.DB.dbClient_id ) {
                    var DB = this.DB.dbClient_id+'-'+this.DB.DB
                } else {
                    var DB = this.DB.DB
                }

                this.Search = search;
                this.Orderby = orderby;
                
                //var client_id = search.client_id;
                //delete search.client_id;

                console.log({ search, project: this.project });
                //console.log('DB',DB);
                
                WebSoc.SEND('search',{ DB, find: search, orderby, project: this.project, count: true },items => {
                //WebSoc.SEND('search',{ DB, find: search, orderby, /*project: this.project, */ count: true },items => {

                    //Array.isArray(items) && console.log('search items',DB,JSON.parse(JSON.stringify(items)));
                    
                    //console.log('items',items);

                    if ( Array.isArray(items) ) {
                        ['customers','wallets'].indexOf(this.DB.DB) > -1 && items.forEach(i => i.components = []);
                        typeof this.DB.onItems == 'function' && this.DB.onItems(items);

                        if ( this.dateFields.length > 0 ) {
                            this.items.forEach(item => {
                                this.dateFields.forEach(field => {
                                    if ( item[field.field] > 0 ) {
                                        this.$set(item,field.field,format(item[field.field],field.format))
                                        //item[field.field] = format(item[field.field],field.format);
                                        console.log('item[field.field]',field.field,item[field.field])
                                    }
                                })
                            })
                        }
                        if ( this.DB.DB.indexOf('-responses') > -1 ) {
                            this.LocalItems = items;
                        } else if ( this.DB.DB ) {
                            this.setDB({ DB: this.DB.DB, items: items });
                        } else {
                            this.items = items;
                        }
                    } 
                    
                    typeof items.count == 'number' && ( this.count = items.count );
                    
                })
            },e ? 300 : 0);


        },
        ...mapMutations([
            'addDB',
            'setDB',
            'downloadCSV'
        ]),
        ...mapActions([
            'getCustomerName'
        ])
    }
}

</script>

<style lang="scss">
   .downloading {
    .bar {
        width: 90%;
        position: absolute;
        left: 5%;
        top: calc(50% - 100px);
        height: 100px;
        background-color: white;
        .progress {
            height: 90px;
            background-color: green;
            margin: 5px;
        }
    }
}    
.list-container {
    min-width: calc(100% - 20px);
    width: auto;
    margin: 10px;
    border: 1px solid #c0c0c0;
    position: relative;
    float: left;

    .list-header {
        border-bottom: 1px solid #c0c0c0;
        p { font-size: 20px; text-align: center; line-height: 34px; padding-top: 4px; }
    }
    p { font-size: 18px; }
    .list-title {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
    }
    .list-count {
        position: absolute;
        left: 0px;
        top: 0px;
        padding: 3px;
        + .x {
            display: none;
        }
    }
    .clear-filter {
        position: absolute;
        top: 0px;
        left: 140px;
        margin: 0px;
        span {
            float: left;
            margin: 3px 10px 0px 0px;
        }
    }
    .responses {
        .list-count {
            left: 0px;
        }
        .x {
            display: inline;
        }
    }
    .list-grid {
        display: grid;
        padding: 5px;
        &.list-row > div {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
        }
        p { width: 95%; min-height: 13px; float: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    }
    .search {
        border-bottom: 1px solid #c0c0c0;  
        input { width: calc(100% - 20px); padding: 5px; font-size: 20px; }
    }
    .list-row {
        &:nth-child(odd) { background-color: rgba(100,100,100,0.1) }
    }
}
       
.list-item {
    > div {
        width: calc(100% - 13px);
        margin-left: 5px;
        overflow: hidden;
    }
} 
.list-container {
    .order {
        float: left;
        margin-top: 7px;
        margin-right: 2px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 0 5px 10px;
        border-color: transparent transparent transparent #007bff;
        &.asc {
            transform: rotate(-90deg);
        }
        &.dec,&.l-1 {
            transform: rotate(90deg);
        }        
    }
}   
.item-search {
    margin: 5px;
    input { width: calc(100% - 10px); padding: 5px; font-size: 18px; }
    p.order {
        float: left;
        margin-top: 7px;
        margin-right: 2px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 0 5px 10px;
        border-color: transparent transparent transparent #007bff;
        &.asc {
            transform: rotate(-90deg);
        }
        &.dec {
            transform: rotate(90deg);
        }
    }
}    
.list-search,.list-item {
    display: grid;
    padding: 8px 0px 6px 0px;
}
.list-item-container {
    &:nth-child(odd) { background-color: rgba(100,100,100,0.15); }
}    
</style>